<template>
  <div>
    <div
      v-for="i in new Array(loaderCount)"
      :key="i"
      class="row main mx-4"
    >
      <div
        v-if="!reverse"
        class="flex image-container"
      >
        <div class="animated-image" />
      </div>
      <div class="flex-grow-1">
        <div class="animated-text">
          <div 
            v-for="lineIndex in new Array(textLineCount)" 
            :key="lineIndex"
            class="animated-text-line" />
        </div>
      </div>
      <div
        v-if="reverse"
        class="flex"
      >
        <div class="animated-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
   props: {
  loaderCount: {
    type: Number,
   default:4
  },
  textLineCount:{
    type: Number,
    default:4
  },
  reverse: {
    type: Boolean,
  }
}
}
</script>

<style scoped>
  div.main{
    padding-block: 10px;
    height: 126px;
    align-items: center;
  }

  .image-container{
    width: 85px;
  }


</style>
